import { render, staticRenderFns } from "./BreadcrumbRow.vue?vue&type=template&id=70a95bd2&"
import script from "./BreadcrumbRow.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports